@if (layersOnly) {
	<!-- Nur Layer-Sektion -->
	<div class="section">
		<div class="section-header">
			<button type="button" class="btn btn-sm btn-outline-dark"
			        [title]="getBlockedHint() || 'Layer/Dienste hinzufügen'"
			        [disabled]="isActionBlocked()"
			        (click)="!isActionBlocked() && onLayersOpened($event)">
				<i class="bi bi-pencil-square"></i>
			</button>
			<span>Layer</span>
		</div>
		<div class="section-body">
			<bp-project-layers></bp-project-layers>
		</div>
	</div>
} @else {
	<!-- Hidden: ProjectsComponent für Download-Logik (absolut positioniert, nimmt keinen Platz ein) -->
	<bp-projects #projectsComp [activeProject]="activeProject()" (selectProject)="selectProject($event)" class="visually-hidden"></bp-projects>

	<!-- Projektname ganz oben (nur wenn Projekt geladen) -->
	@if (activeProject()) {
		<div class="project-name-header">
			{{ activeProjectName() }}
		</div>
	}

	<!-- Projekt-Aktionen -->
	<div class="project-header">
		<div ngbDropdown container="body" (openChange)="onProjectDropdownOpen($event)">
			<button type="button" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle>
				{{ activeProject() ? entityLabel.name + ' wechseln' : entityLabel.name + ' laden...' }}
			</button>
				<div ngbDropdownMenu class="project-dropdown-menu">
					@for (prj of projectList(); track prj._id) {
						<button ngbDropdownItem (click)="selectProject(prj._id)" [class.active]="prj._id === activeProject()" class="project-dropdown-item">
							<div class="d-flex align-items-center gap-2">
								<!-- Offline-/Sync-Status-Icon -->
								@if (getProjectStatus(prj._id) === 'pending') {
									<i class="bi bi-cloud-arrow-up text-warning" style="font-size: 1rem;" title="Lokale Änderungen vorhanden"></i>
								} @else if (getProjectStatus(prj._id) === 'complete') {
									<i class="bi bi-cloud-check text-success" style="font-size: 1rem;" title="Offline verfügbar"></i>
								} @else if (getProjectStatus(prj._id) === 'partial' || getProjectStatus(prj._id) === 'geodata_missing') {
									<i class="bi bi-cloud-download text-info" style="font-size: 1rem;" title="Teilweise heruntergeladen"></i>
								} @else {
									<i class="bi bi-cloud text-muted" style="font-size: 1rem;" title="Nicht offline verfügbar"></i>
								}
								<span class="project-name">{{ prj.name }}</span>
							</div>
							@if (prj.owner || hasAnyMembers(prj)) {
								<div class="project-members">
									@if (prj.owner) {
										<span title="Eigentümer"><i class="bi bi-person-fill"></i> {{ prj.owner.username }}</span>
									}
									@for (role of rolesConfig.memberRoles; track role.field) {
										@if (prj[role.field]?.length) {
											<span [title]="role.label"><i class="bi" [ngClass]="role.icon"></i> {{ formatMembers(prj[role.field]) }}</span>
										}
									}
								</div>
							}
						</button>
					}
					@if (projectList().length === 0) {
						<span class="dropdown-item-text text-muted small">Keine {{ entityLabel.namePlural }} vorhanden</span>
					}
				</div>
		</div>
		<!-- Aktions-Menü -->
		<div ngbDropdown container="body">
			<button type="button" class="btn btn-sm btn-outline-dark" ngbDropdownToggle [title]="entityLabel.name + '-Aktionen'">
				<i class="bi bi-three-dots-vertical"></i>
			</button>
			<div ngbDropdownMenu>
				<button ngbDropdownItem (click)="!isActionBlocked() && onProjectNew()" [class.disabled]="isActionBlocked()" [title]="getBlockedHint()">
					<i class="bi bi-plus-circle me-2"></i>{{ entityLabel.newLabel }}...
				</button>
				@if (activeProject()) {
					<button ngbDropdownItem (click)="!isActionBlocked() && onProjectEdit()" [class.disabled]="isActionBlocked()" [title]="getBlockedHint()">
						<i class="bi bi-pencil me-2"></i>Bearbeiten
					</button>
					<button ngbDropdownItem (click)="selectProject('')">
						<i class="bi bi-x-circle me-2"></i>Schließen
					</button>
					<div class="dropdown-divider"></div>
					<button ngbDropdownItem class="text-danger" (click)="!isActionBlocked() && onProjectDelete()" [class.disabled]="isActionBlocked()" [title]="getBlockedHint()">
						<i class="bi bi-trash me-2"></i>Löschen
					</button>
					@if (extraActions.length > 0) {
						<div class="dropdown-divider"></div>
						@for (action of extraActions; track action.label) {
							<button ngbDropdownItem (click)="!isActionBlocked() && action.action()" [class.disabled]="isActionBlocked()" [title]="getBlockedHint()">
								<i class="bi {{ action.icon }} me-2"></i>{{ action.label }}
							</button>
						}
					}
					<div class="dropdown-divider"></div>
					<button ngbDropdownItem class="text-success fw-bold" (click)="!networkUnavailable() && onDownload()" [class.disabled]="networkUnavailable()" [title]="networkUnavailable() ? networkHint : ''">
						<i class="bi bi-cloud-download me-2"></i>Download
					</button>
				}
			</div>
		</div>
	</div>

	<!-- Unterkategorien (nur wenn Projekt aktiv) -->
	@if (activeProject()) {
		<!-- Bereiche -->
		<div class="section sub-section">
			<div class="section-header clickable" (click)="toggleRegionsSection()">
				<i class="bi" [class.bi-chevron-down]="!regionsSectionCollapsed()" [class.bi-chevron-right]="regionsSectionCollapsed()"></i>
				<span class="flex-grow-1">Bereiche</span>
				<button type="button" class="btn btn-sm btn-outline-dark"
				        [title]="getBlockedHint() || 'Bereiche bearbeiten'"
				        [disabled]="isActionBlocked()"
				        (click)="!isActionBlocked() && onRegionsOpened($event)">
					<i class="bi bi-pencil-square"></i>
				</button>
			</div>
			@if (!regionsSectionCollapsed()) {
				<div class="section-body">
					<bp-project-regions></bp-project-regions>
				</div>
			}
		</div>

		<!-- Layer -->
		<div class="section sub-section">
			<div class="section-header clickable" (click)="toggleLayersSection()">
				<i class="bi" [class.bi-chevron-down]="!layersSectionCollapsed()" [class.bi-chevron-right]="layersSectionCollapsed()"></i>
				<span class="flex-grow-1">Layer</span>
				<button type="button" class="btn btn-sm btn-outline-dark"
				        [title]="getBlockedHint() || 'Layer/Dienste hinzufügen'"
				        [disabled]="isActionBlocked()"
				        (click)="!isActionBlocked() && onLayersOpened($event)">
					<i class="bi bi-pencil-square"></i>
				</button>
			</div>
			@if (!layersSectionCollapsed()) {
				<div class="section-body">
					<bp-project-layers></bp-project-layers>
				</div>
			}
		</div>
	}

	<!-- Modus-Toggle (Online ↔ Offline) -->
	@if (hasProjectRegions()) {
		<div class="mode-toggle-container">
			<div class="mode-toggle" [class.offline]="offlineActive()" [class.switching]="isSwitchingMode()" (click)="!isSwitchingMode() && onModeToggle()">
				<!-- Online-Szene: Person vor Bildschirm -->
				<div class="scene scene-online">
					<svg viewBox="0 0 100 60" class="scene-svg">
						<!-- Monitor -->
						<rect x="50" y="8" width="28" height="20" rx="2" fill="#333"/>
						<rect x="52" y="10" width="24" height="16" fill="#6ab0de"/>
						<rect x="62" y="28" width="4" height="4" fill="#444"/>
						<rect x="56" y="32" width="16" height="2" fill="#555"/>
						<!-- Person (sitzend, Oberkörper) - person.svg angepasst -->
						<g transform="translate(12, 8) scale(0.08)">
							<path fill="#444" d="M256.005,300.641c74.144,0,134.231-60.108,134.231-134.242v-32.158C390.236,60.108,330.149,0,256.005,0c-74.155,0-134.252,60.108-134.252,134.242V166.4C121.753,240.533,181.851,300.641,256.005,300.641z"/>
							<path fill="#444" d="M458.159,404.216c-18.93-33.65-49.934-71.764-100.409-93.431c-28.868,20.196-63.938,32.087-101.745,32.087c-37.828,0-72.898-11.89-101.767-32.087c-50.474,21.667-81.479,59.782-100.398,93.431C28.731,448.848,48.417,512,91.842,512c43.426,0,164.164,0,164.164,0s120.726,0,164.153,0C463.583,512,483.269,448.848,458.159,404.216z"/>
						</g>
					</svg>
				</div>
				<!-- Offline-Szene: Person im Wald -->
				<div class="scene scene-offline">
					<svg viewBox="0 0 100 60" class="scene-svg">
						<!-- Hintere Bäume (hinter der Person) -->
						<polygon points="8,45 16,5 24,45" fill="#2d5a27"/>
						<rect x="14" y="45" width="4" height="6" fill="#5a4a3a"/>
						<polygon points="76,45 86,2 96,45" fill="#2d5a27"/>
						<rect x="84" y="45" width="4" height="6" fill="#5a4a3a"/>
						<!-- Person (gehend) - Füße auf Bodenhöhe -->
						<g transform="translate(43, 10) scale(0.08)">
							<path fill="#444" d="M234.683,103.486c28.583,0,51.747-23.164,51.747-51.742C286.43,23.165,263.266,0,234.683,0c-28.578,0-51.747,23.165-51.747,51.743C182.936,80.322,206.104,103.486,234.683,103.486z"/>
							<path fill="#444" d="M346.194,405.297l-23.056-106.532L312.5,186.72c-6.905-74.294-78.897-68.97-114.04-34.555l-58.407,59.888l-56.13,20.688c-10.63,3.917-16.342,15.473-12.981,26.294l0.264,0.828c3.3,10.638,14.264,16.93,25.118,14.43l45.745-10.564c11.408-2.632,22.24-7.326,31.94-13.867l31.811-21.393l11.239,85.412c0.82,6.259-6.549,32.602-8.229,38.712L166.95,476.181c-3.635,13.113,4.019,26.699,17.12,30.408l0.915,0.248c12.389,3.494,25.391-3.088,29.895-15.143l58.56-119.57l16.259,52.132c2.389,4.76,5.547,9.082,9.356,12.798l65.94,68.068c9.032,8.809,23.313,9.207,32.8,0.894l1.143-0.994c4.86-4.255,7.823-10.282,8.205-16.731c0.389-6.45-1.822-12.791-6.143-17.584L346.194,405.297z"/>
							<path fill="#444" d="M442.021,286.323l-6.284-68.019c-3.85-41.642-40.459-72.448-82.142-69.136l-16.028,1.275l13.222,143.141L442.021,286.323z"/>
						</g>
						<!-- Vorderer Baum (vor der Person, verdeckt teilweise) -->
						<polygon points="28,45 38,10 48,45" fill="#3d7a37"/>
						<rect x="36" y="45" width="4" height="6" fill="#5a4a3a"/>
					</svg>
				</div>
				<!-- Slider-Knob -->
				<div class="mode-slider">
					@if (isSwitchingMode()) {
						<div class="mode-spinner"></div>
					}
				</div>
			</div>
			<div class="mode-label">
				@if (isSwitchingMode()) {
					Wird gewechselt...
				} @else {
					{{ offlineActive() ? 'Offline-Modus' : 'Online-Modus' }}
				}
			</div>
		</div>
	}


	<!-- Ladeanzeige ganz unten -->
	@if (isLoading() && activeProject()) {
		<div class="d-flex align-items-center justify-content-center text-muted small py-3">
			<span class="spinner-border spinner-border-sm me-2"></span>
			<span>{{ mss.tilesLoading() > 0 ? 'Karte wird geladen...' : entityLabel.name + ' wird geladen...' }}</span>
		</div>
	}
}
